import React from "react";
import SdRsvpPage from "../sd/SdRsvpPage";
import { CHOW_CALL_EVENTS } from "./chowCallEvents";

export default function ChowCallVfw981() {
  return (
    <SdRsvpPage
      event={CHOW_CALL_EVENTS.vfw981}
      topLabel="Road Home Program Chicago Chow Call"
      thankYouPath="/chow-call/thank-you"
      showTeamSection={false}
      unavailableLabel="Dinner reservations coming soon"
      unavailableMessage="The RSVP form will appear once the dinner reservation slot is available."
    />
  );
}
